import { HiverAxios } from 'h-commons';
import {
    GET_UPGRADE_PLANS_DONE,
    GET_UPGRADE_PLANS_FAILED,
    GET_UPGRADE_PLANS_INIT
} from './types';

export const getUpgradePlans = () => (dispatch) => {
    dispatch({
        type: GET_UPGRADE_PLANS_INIT
    });
    HiverAxios({
        url: '/api/account/plan',
        type: 'GET',
        callback: resp => {
            if (resp.data && resp.data.success) {
                const { annualPlans, monthlyPlans, activeusers, annualPlansIds, monthlyPlansIds, currentplanvalues, currentplan }  = resp.data.data.planSlabs;
                const { StripePublishKey, stripeId, chargebeeId } = resp.data.data;
                dispatch({
                    type: GET_UPGRADE_PLANS_DONE,
                    payload: {
                        availablePlans: {
                            annual: annualPlans,
                            monthly: monthlyPlans
                        },
                        annualPlansIds,
                        monthlyPlansIds,
                        current: { planid: currentplan, ...currentplanvalues},
                        activeUsers: activeusers,
                        STRIPE_PUBLISH_KEY: StripePublishKey,
                        stripeId,
                        chargebeeId

                    }
                })
            } else {
                dispatch({ type: GET_UPGRADE_PLANS_FAILED });
            }
        },
        onfail: () => dispatch({ type: GET_UPGRADE_PLANS_FAILED })
    })
}